/*
 * @Author: zhushitao
 * @Date: 2021-07-21 15:14:17
 * @LastEditors: zhushitao
 * @LastEditTime: 2021-10-19 21:27:31
 * @Description:
 */

export enum Region {
  cn = 'cn',
  sg = 'sg',
}

export const apiOrigin = {
  [Region.cn]: 'https://ngcc-boe.bytedance.net',
  [Region.sg]: 'https://ngcc-cloud-oversea-boe.bytedance.net',
};

export const imCloudConfig = {
  [Region.cn]: {
    appId: 1402,
    appKey: 'e0f82475ab9dbf5717d18b4a9c0d7fd0',
    fpId: 89,
    service: 2,
    apiUrl: 'https://imapi-boe.bytedance.net/',
    frontierUrl: 'wss://frontier-boe.bytedance.net/ws/v2',
    uploadRegion: 'boe',
    videoDomain: 'https://staging-openapi-boe.byted.org',
    imageDomain: 'https://staging-openapi-boe.byted.org',
  },
  [Region.sg]: {
    appId: 4946,
    appKey: 'e0f82475ab9dbf5717d18b4a9c0d7fd0',
    fpId: 89,
    service: 2,
    method: 1,
    apiUrl: 'http://imapi-boei18n.byted.org', // http://imapi-va-oth.isnssdk.com.boe-gateway.byted.org
    frontierUrl: 'wss://frontier-boei18n.bytedance.net/ws/v2',
    uploadRegion: 'boei18n',
    videoDomain: 'https://vas-boei18n.bytedance.net',
    imageDomain: 'https://vas-boei18n.bytedance.net',
  },
};
